export default __webpack_public_path__ + "static/media/hydra-guard.d818ee02.png";